import React, { memo, useCallback, useMemo } from 'react';
import { Button } from '@chakra-ui/react';
import { Box } from '@chakra-ui/layout';
import { CustomIcon } from 'components';
import useEventBus from 'hooks/useEventBus';
import { IMenuItem } from '../../cards';
import { openNotification } from 'utils/notification';
import { useHistory } from 'react-router';
import { checkPermission } from 'utils/authentication';

interface IProps {
  id: number;
  icon: IMenuItem['icon'];
  text: string;
  onPopup?: IMenuItem['onPopup'];
  disabled?: boolean;
  isPage: boolean;
  href?: string;
  userType?: IMenuItem['userType'];
}

const CardButtonComp: React.FC<IProps> = ({
  text,
  icon,
  onPopup,
  href,
  disabled,
  userType,
  isPage,
}) => {
  const eventBus = useEventBus();
  const history = useHistory();
  const handleClick = useCallback(() => {
    onPopup && eventBus.dispatchEvent('onPopup', onPopup);
    href && history.push(href);
  }, [eventBus, href, onPopup]);

  const noAccess = useMemo(
    () =>
      !!userType &&
      !checkPermission({
        onlyAdmin: userType === 'admin',
        onlyClient: userType === 'client',
      }),
    [userType],
  );

  const isDisabled = useMemo(() => !!(disabled || noAccess), []);

  return (
    <Box position="relative" w="auto" h="auto" as="div">
      <Button
        _hover={!disabled ? { backgroundColor: 'brand.tertiary', color: 'brand.white' } : undefined}
        width="368px"
        height="176px"
        border="1px solid"
        px="24px"
        borderColor="brand.tertiary"
        bg="brand.white"
        margin="8px"
        onClick={handleClick}
        disabled={isDisabled}
        flexDir="column"
        whiteSpace="break-spaces"
        gridGap="22px"
        filter="drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.1))"
        alignItems="flex-start"
        textAlign="start"
      >
        <Box as="div" ml="16px">
          <CustomIcon position={icon.position} size={icon.size} icon={icon.type} />
        </Box>
        {text}
      </Button>
      {isDisabled && (
        <Box
          onClick={() => {
            if (isDisabled && isPage === false) {
              openNotification(
                'Função indisponível. Estamos trabalhando para lançar esta função em breve!',
                'info',
              );
            } else if (isDisabled && isPage) {
              openNotification('Você não possui acesso a esta função.', 'warn');
            }
          }}
          w="100%"
          h="100%"
          top="0"
          left="0"
          position="absolute"
        />
      )}
    </Box>
  );
};

export const CardButton = memo(CardButtonComp);
